import { connect } from 'react-redux'

import DisplayMode from '../../../pages/settings/components/HeadOnglet/displayMode'
import { getObjectModeDisplay } from '../../../redux/filter/selectors'
import { saveModeDisplaySetting } from '../../../redux/filter/actions'

const mapStateToProps = (state) => ({
  objectModeDisplay: getObjectModeDisplay(state),
})

const mapDisptachToProps = (dispatch) => ({
  saveModeDisplaySetting: (objectModeDisplay) =>
    dispatch(saveModeDisplaySetting(objectModeDisplay)),
})

export default connect(mapStateToProps, mapDisptachToProps)(DisplayMode)
